// extracted by mini-css-extract-plugin
module.exports = {"content":"WorkType_content__1Jtwn","submitBtn":"WorkType_submitBtn__1HLP7"};